module.exports = __webpack_public_path__ + "img/uid-token-game-guide-global-vi.eea5ecd6.png";